<template>
  <div class="container">
    <div id="carouselExampleDark" class="carousel slide" data-bs-ride="true">
      <div class="carousel-indicators" style="margin-bottom: -0.5rem">
        <!-- 按鈕1 -->
        <button
          type="button"
          data-bs-target="#carouselExampleDark"
          data-bs-slide-to="0"
          class="active"
          aria-current="true"
          aria-label="Slide 1"
        ></button>

        <!-- 按鈕2 -->
        <button
          type="button"
          data-bs-target="#carouselExampleDark"
          data-bs-slide-to="1"
          aria-label="Slide 2"
        ></button>

        <!-- 按鈕3 -->
        <button
          type="button"
          data-bs-target="#carouselExampleDark"
          data-bs-slide-to="2"
          aria-label="Slide 3"
        ></button>

        <!-- 按鈕4 -->
        <button
          type="button"
          data-bs-target="#carouselExampleDark"
          data-bs-slide-to="3"
          aria-label="Slide 4"
        ></button>

        <!-- 按鈕5 -->
        <button
          type="button"
          data-bs-target="#carouselExampleDark"
          data-bs-slide-to="4"
          aria-label="Slide 5"
        ></button>

      </div>

      <div class="carousel-inner">

        <!-- Banner 1 -->
        <div class="carousel-item active" data-bs-interval="10000">
          <div class="row">
            <div
              class="T-light col-lg-6 d-flex flex-column justify-content-center pt-4 pt-lg-0 order-1 order-lg-1"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <span class="T1">老師必備！</span>
              <span class="T2">免費體驗30天</span>
              <span class="T2">開口說英文的教學系統</span>
              <span class="T3">
                <strong>Supersite線上平台｜老師發音教學的神器 </strong><br />
                ✨ 不用費時備課，也能打造高品質英文課 ✨ <br />
                ✨ 結合閱讀 × 發音 × 線上互動教材 ✨</span
              >
              <div class="justify-content-center justify-content-lg-start">
                <a
                  href="https://forms.gle/yENRmuRazV7rCzQo8"
                  target="_blank"
                  class="btn-more scrollto"
                  >免費試用｜立即開通 ▶
                </a>
              </div>
            </div>
            <div
              class="col-lg-6 order-1 order-lg-2 hero-img"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <img
                src="../assets/img-1/Banner/program-Gr.1.png"
                class="img-fluid animated"
                alt="Banner 1"
              />
            </div>
          </div>
        </div>

        <!-- Banner 2 -->
        <div class="carousel-item" data-bs-interval="10000">
          <div class="row">
            <div
              class="T-light col-lg-6 d-flex flex-column justify-content-center pt-4 pt-lg-0 order-3 order-lg-1"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <span class="T1">聯洋陪你~</span>
              <span class="T2">建立孩子的英文基礎</span>
              <span class="T3">
                Discover Phonics (Grades K~3)全套共有4冊，<br />
                透過充滿活力的歌曲、<br />
                依循漸進的自然發音讀本、豐富的多媒體，<br />
                在邊學邊玩的過程中建立自信心，<br />
                讓孩子從初級閱讀者發展為流利的閱讀者。</span
              >
              <div class="justify-content-center justify-content-lg-start">
                <a
                  href="/BookPage/PhonicPage/DiscoverPhonics"
                  target="_blank"
                  class="btn-more scrollto"
                  >了解更多 ▶
                </a>
              </div>
            </div>
            <div
              class="col-lg-6 order-2 order-lg-2 hero-img"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <img
                src="../assets/img-1/Banner/01_Banner_small_Phonics.png"
                class="img-fluid animated"
                alt="Banner 2"
              />
            </div>
          </div>
        </div>

        <!-- Banner 3 -->
        <div class="carousel-item" data-bs-interval="10000">
          <div class="row">
            <div
              class="T-light col-lg-6 d-flex flex-column justify-content-center pt-3 pt-lg-0 order-3 order-lg-1"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <span class="T1">聯洋陪你~</span>
              <span class="T2">增強孩子的英文閱讀能力</span>
              <span class="T3">
                Connect(Grades K-6) 全套共有7冊，<br />
                透過系統化及結構化的教學方式，<br />
                活潑且實用地將英文教學連結至其他科目，<br />
                進而有效提高孩子的閱讀技能。</span
              >
              <div class="justify-content-center pb justify-content-lg-start">
                <a
                  href="/BookPage/ReadingPage/VistaConnectGK"
                  target="_blank"
                  class="btn-more scrollto pb"
                  >Grade K ▶
                </a>
                <a
                  href="/BookPage/ReadingPage/VistaConnectEnglishG1-6"
                  target="_blank"
                  class="btn-more scrollto pb"
                  >Grades 1-6 ▶
                </a>
              </div>
            </div>
            <div
              class="col-lg-6 order-3 order-lg-2 hero-img"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <img
                src="../assets/img-1/Banner/02_Banner_small_Connect.png"
                class="img-fluid animated"
                alt="Banner 3"
              />
            </div>
          </div>
        </div>

        <!-- Banner 4 -->
        <div class="carousel-item" data-bs-interval="10000">
          <div class="row">
            <div
              class="T-light col-lg-6 d-flex flex-column justify-content-center pt-3 pt-lg-0 order-4 order-lg-1"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <span class="T1">聯洋陪你~</span>
              <span class="T2">強化孩子聽說讀寫</span>
              <span class="T2">全方位的英文能力</span>
              <span class="T3">
                Bridges (Grades 6~8)全套共有3冊，<br />
                旨在培養中學生的自主閱讀能力。<br />
                豐富的線上學習資源以及跨學科的內容，<br />
                為孩子的英語學習增添更多的動力。</span
              >
              <div class="justify-content-center justify-content-lg-start">
                <a
                  href="/BookPage/ReadingPage/VistaBridgesG6-8"
                  target="_blank"
                  class="btn-more scrollto"
                  >了解更多 ▶
                </a>
              </div>
            </div>
            <div
              class="col-lg-6 order-4 order-lg-2 hero-img"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <img
                src="../assets/img-1/Banner/03_Banner_small_Bridges.png"
                class="img-fluid animated"
                alt="Banner 4"
              />
            </div>
          </div>
        </div>

        <!-- Banner 5 -->
        <div class="carousel-item" data-bs-interval="10000">
          <div class="row">
            <div
              class="T-light col-lg-6 d-flex flex-column justify-content-center pt-3 pt-lg-0 order-5 order-lg-1"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <span class="T1">聯洋陪你~</span>
              <span class="T2">在孩子進入大學前</span>
              <span class="T2">做最好的準備</span>
              <span class="T3">
                Engage (Grades 9~12) 全套共有4冊，針對高中生而設計。<br />
                旨在幫助所有學生在進入大學階段和未來志向做好準備，<br />
                讓孩子成為強大的讀者、自信的作家和批判性思考者。</span
              >
              <div class="justify-content-center justify-content-lg-start">
                <a
                  href="/BookPage/ReadingPage/VistaEngageG9-12"
                  target="_blank"
                  class="btn-more scrollto"
                  >了解更多 ▶
                </a>
              </div>
            </div>
            <div
              class="col-lg-6 order-5 order-lg-2 hero-img"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <img
                src="../assets/img-1/Banner/04_Banner_small_Engage.png"
                class="img-fluid animated"
                alt="Banner 5"
              />
            </div>
          </div>
        </div>
      </div>

      <button
        class="carousel-control-prev"
        style="top: 50%; left: -140px; opacity: 1"
        type="button"
        data-bs-target="#carouselExampleDark"
        data-bs-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button
        class="carousel-control-next"
        style="top: 50%; right: -140px; opacity: 1"
        type="button"
        data-bs-target="#carouselExampleDark"
        data-bs-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </div>
</template>
``
<style>
.T1 {
  display: block;

  font-size: 24px;
  font-weight: 700;
  color: #111;

  text-shadow: 0 0 6px rgba(255, 255, 255, 0.95),
    0 0 12px rgba(255, 255, 255, 0.85);

  margin-bottom: 8px;
}

.T2 {
  display: block;

  font-size: 54px;
  font-weight: 900;
  line-height: 1.2;

  color: #111;

  white-space: nowrap;

  text-shadow: 0 0 8px rgba(255, 255, 255, 1), 0 0 18px rgba(255, 255, 255, 0.9),
    0 4px 10px rgba(255, 255, 255, 0.7);

  margin-bottom: 20px;
}

.T3 {
  display: block;

  font-size: 22px;
  font-weight: 700;
  line-height: 1.8;

  color: #111;

  text-shadow: 0 0 6px rgba(255, 255, 255, 0.95),
    0 0 12px rgba(255, 255, 255, 0.85);
}

.btn-more {
  font-size: 18px;
  letter-spacing: 1px;
  display: inline-block;
  padding: 6px 18px;
  border-radius: 50px;
  transition: 0.5s;
  margin: 28px 0 0 0;
  color: #fff;
  background: #00489b;
}

.T-light {
  text-shadow: 0px 0px 3px rgb(0, 14, 78);
}

a:hover {
  color: #00489b;
  text-shadow: 0px 0px 3px #fff, 0px 0px 3px #fff, 0px 0px 3px #fff,
    0px 0px 3px #fff;
}

.pb {
  margin: 10px 10px;
}

/* 手機版 */
@media (max-width: 768px) {
  .T1 {
    font-size: 16px;
    text-align: center;
    margin-bottom: 6px;
  }

  .T2 {
    font-size: 30px;
    line-height: 1.35;
    white-space: normal;

    text-align: center;

    margin-bottom: 14px;
  }

  .T3 {
    font-size: 14px;
    line-height: 1.8;

    text-align: center;
  }

  .btn-more {
    font-size: 14px;
    padding: 6px 16px;
    margin-top: 18px;
  }
}
</style>

<!-- 書展資訊 -->
<!-- <div class="carousel-item active" data-bs-interval="10000">
  <div class="row">
    <div
      class="T-light col-lg-6 d-flex flex-column justify-content-center pt-4 pt-lg-0 order-1 order-lg-1"
      data-aos="fade-up"
      data-aos-delay="200"
    >
      <span class="T1">2025台北國際書展 即將展開!</span> 
      <span class="T2"
        >2025台北國際書展即將展開</span
      >
      <span class="T3">
        今年書展備有全新教材及深受雙語中小學喜愛使用的教材，<br />
        歡迎您蒞臨賞書~2025/2/4-2/9 聯洋文化 在外文書區D606，<br />
        期待與您見面! <br /></span
      >
      <div class="justify-content-center justify-content-lg-start">
        <a
          href="https://tibeonline.tw/show-publisher/26246/"
          target="_blank"
          class="btn-more scrollto"
          >了解更多 ▶
        </a>
      </div>
    </div>
    <div
      class="col-lg-6 order-1 order-lg-2 hero-img"
      data-aos="zoom-in"
      data-aos-delay="200"
    >
      <img
        src="../assets/img-1/TIBEbanner-02.png"
        class="img-fluid animated"
        alt="Banner 1"
      />
    </div>
  </div>
</div> -->
<!-- Banner 1 -->
<!-- <div class="carousel-item active" data-bs-interval="10000">
          <div class="row">
            <div
              class="T-light col-lg-6 d-flex flex-column justify-content-center pt-4 pt-lg-0 order-1 order-lg-1"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <span class="T1">聯洋祝你~</span>
              <span class="T2">兒童節快樂~</span>
              <span class="T3">
                清明連假期間：<strong>4月3日（四）～ 4月6日（日）</strong><br />
                這段時間將暫停客服與出貨服務，<br />
                若您有任何詢問或訂單需求，<br />
                我們將於 <strong>4月7日（一）</strong>起陸續回覆與處理。</span
              >
              <div class="justify-content-center justify-content-lg-start">
                <a
                  href="/"
                  target="_blank"
                  class="btn-more scrollto"
                  >最棒的兒童節禮物 ▶
                </a>
              </div>
            </div>
            <div
              class="col-lg-6 order-1 order-lg-2 hero-img"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <img
                src="../assets/img-1/world kids.png"
                class="img-fluid animated"
                alt="Banner 1"
              />
            </div>
          </div>
        </div> -->
